import {
  memo,
  useCallback,
} from 'react';
import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { PageSizeOption } from './PageSizeOption';

const StyledMenu = styled.div({
  paddingTop: 12,
  paddingBottom: 12,
});

const StyledLabel = styled.div(({
  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.LABEL,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  paddingBottom: indents.INDENT_1,
  color: colors.NEUTRAL_SECONDARY,
}));

export type PageSizeSelectMenuProps = {
  value: number;
  options: number[];

  onChange: (nextValue: number) => void;
  close: () => void;
};

function PageSizeSelectMenuInner({
  value,
  options,
  onChange,
  close,
}: PageSizeSelectMenuProps): ReactElement {
  const onSelect = useCallback((nextValue: number): void => {
    close();

    if (value !== nextValue) {
      onChange(nextValue);
    }
  }, [value, close, onChange]);

  return (
    <StyledMenu>
      <StyledLabel>
        Показывать по:
      </StyledLabel>

      <div>
        {
          options.map((option) => (
            <PageSizeOption
              value={value}
              option={option}
              onSelect={onSelect}
              key={option}
            />
          ))
        }
      </div>
    </StyledMenu>
  );
}

export const PageSizeSelectMenu = memo(PageSizeSelectMenuInner);
